module.exports = __webpack_public_path__ + "img/corcho-azul.f4b5f481.png";